import { EmailTemplateAttachment } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const upsertEmailTemplateAttachments: (
  fetchContext: FetchContext,
  programId: number,
  emailTemplateId: number,
  emailTemplateAttachments: EmailTemplateAttachment[],
  accessToken?: string,
) => Promise<void> = async (fetchContext, programId, emailTemplateId, emailTemplateAttachments, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}/attachments`,
  {
    method: 'PUT',
    body: JSON.stringify(emailTemplateAttachments),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'upsert email template attachments'));
